/**
 * A 股交易日历（与小程序 trading-calendar.js 一致）
 */

function pad2(n) {
  return String(n).padStart(2, '0');
}

export function fmtLocalYMD(d) {
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function parseLocalYMD(dateStr) {
  const s = String(dateStr || '').slice(0, 10);
  const p = s.split('-');
  const y = parseInt(p[0], 10);
  const m = parseInt(p[1], 10);
  const day = parseInt(p[2], 10);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(day)) return new Date();
  return new Date(y, m - 1, day);
}

const HOLIDAYS_2025 = [
  '2025-01-28', '2025-01-29', '2025-01-30', '2025-01-31',
  '2025-02-01', '2025-02-02', '2025-02-03',
  '2025-04-05', '2025-04-06', '2025-04-07',
  '2025-05-01', '2025-05-02', '2025-05-03', '2025-05-04', '2025-05-05',
  '2025-05-31', '2025-06-01', '2025-06-02',
  '2025-10-06', '2025-10-07', '2025-10-08',
  '2025-10-01', '2025-10-02', '2025-10-03', '2025-10-04', '2025-10-05'
];

const HOLIDAYS_2026 = [
  '2026-01-01', '2026-01-02',
  '2026-02-16', '2026-02-17', '2026-02-18', '2026-02-19', '2026-02-20', '2026-02-23',
  '2026-04-06',
  '2026-05-01', '2026-05-04', '2026-05-05',
  '2026-06-19',
  '2026-09-25',
  '2026-10-01', '2026-10-02', '2026-10-03', '2026-10-04', '2026-10-05', '2026-10-06', '2026-10-07'
];

const ALL_HOLIDAYS = new Set([...HOLIDAYS_2025, ...HOLIDAYS_2026]);

export function isTradingDay(dateStr) {
  try {
    const d = parseLocalYMD(dateStr);
    const w = d.getDay();
    if (w === 0 || w === 6) return false;
    const key = String(dateStr).slice(0, 10);
    if (ALL_HOLIDAYS.has(key)) return false;
    return true;
  } catch (error) {
    return true;
  }
}

export function getNthPrevTradingDayExclusive(fromNaturalYmd, n) {
  const lim = Math.max(1, Number(n) || 1);
  let d = parseLocalYMD(fromNaturalYmd);
  d.setDate(d.getDate() - 1);
  let count = 0;
  for (let guard = 0; guard < 400; guard += 1) {
    const s = fmtLocalYMD(d);
    if (isTradingDay(s)) {
      count += 1;
      if (count === lim) return s;
    }
    d.setDate(d.getDate() - 1);
  }
  return '';
}

export function todayYMD() {
  try {
    if (typeof Intl !== 'undefined' && Intl.DateTimeFormat?.prototype?.formatToParts) {
      const parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Asia/Shanghai',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      const y = parts.find((p) => p.type === 'year');
      const m = parts.find((p) => p.type === 'month');
      const day = parts.find((p) => p.type === 'day');
      if (y?.value && m?.value && day?.value) {
        return `${y.value}-${m.value}-${day.value}`;
      }
    }
  } catch (error) {
    // ignore
  }
  return fmtLocalYMD(new Date());
}

export function defaultProfitAnchorDate() {
  return getNthPrevTradingDayExclusive(todayYMD(), 1) || todayYMD();
}

export function getNthNextTradingDayStrictlyAfter(fromYmd, n = 1) {
  const lim = Math.max(1, Number(n) || 1);
  let d = parseLocalYMD(fromYmd);
  d.setDate(d.getDate() + 1);
  let count = 0;
  for (let guard = 0; guard < 400; guard += 1) {
    const s = fmtLocalYMD(d);
    if (isTradingDay(s)) {
      count += 1;
      if (count === lim) return s;
    }
    d.setDate(d.getDate() + 1);
  }
  return '';
}

export function getNextTradingDayStrictlyAfter(navYmd) {
  return getNthNextTradingDayStrictlyAfter(navYmd, 1);
}

export function getTradingTargetsForProfitStatus(naturalYmd) {
  const natural = naturalYmd ? String(naturalYmd).slice(0, 10) : todayYMD();
  const targetT1 = getNthPrevTradingDayExclusive(natural, 1);
  const targetT2 = getNthPrevTradingDayExclusive(natural, 2);
  return { natural, targetT1, targetT2 };
}
